// Offer-level shipping and returns markup — ONE implementation shared by the
// prerendered product JSON-LD (scripts/prerender-body.mjs) and the React one
// (src/components/JsonLd.tsx). Google's merchant listings (free Shopping-tab
// results) read these fields; both blocks describe the same product via @id.
//
// Terms come from src/lib/shipping.ts and the returns page. Keep in sync:
// prerender-og asserts the free-shipping threshold matches shipping.ts.
export const OFFER_FREE_SHIPPING_THRESHOLD = 120;
export const OFFER_FLAT_SHIPPING_RATE = 9.9;

/** Stable node id so Google merges the prerendered and the React Product block. */
export const productNodeId = (url) => `${url}#product`;

export function offerPolicy(price, currency = "USD") {
  return {
    itemCondition: "https://schema.org/NewCondition",
    seller: { "@type": "Organization", name: "LoftLoom" },
    shippingDetails: {
      "@type": "OfferShippingDetails",
      shippingRate: {
        "@type": "MonetaryAmount",
        value: Number(price) >= OFFER_FREE_SHIPPING_THRESHOLD ? "0" : OFFER_FLAT_SHIPPING_RATE.toFixed(2),
        currency,
      },
      shippingDestination: { "@type": "DefinedRegion", addressCountry: "US" },
      // Fulfilling store's policy: processed in 1–5 business days, delivered in
      // 4–10 business days including processing (U.S.).
      deliveryTime: {
        "@type": "ShippingDeliveryTime",
        handlingTime: { "@type": "QuantitativeValue", minValue: 1, maxValue: 5, unitCode: "DAY" },
        transitTime: { "@type": "QuantitativeValue", minValue: 3, maxValue: 5, unitCode: "DAY" },
      },
    },
    // 30 days from delivery, unused and in original packaging, by mail; the
    // customer pays return shipping unless the item arrived damaged, defective
    // or incorrect.
    hasMerchantReturnPolicy: {
      "@type": "MerchantReturnPolicy",
      applicableCountry: ["US", "CA"],
      returnPolicyCategory: "https://schema.org/MerchantReturnFiniteReturnWindow",
      merchantReturnDays: 30,
      returnMethod: "https://schema.org/ReturnByMail",
      returnFees: "https://schema.org/ReturnFeesCustomerResponsibility",
    },
  };
}
